import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["notification"]
  static COOKIE_NAME = 'chatbot_preferences_seen'
  static COOKIE_DURATION_YEARS = 1

  connect() {
    this.checkNotificationStatus()
  }

  checkNotificationStatus() {
    const hasSeenPreferences = this.getCookie(this.constructor.COOKIE_NAME)
    
    if (!hasSeenPreferences) {
      this.showNotification()
    } else {
      this.hideNotification()
    }
  }

  hideNotification() {
    if (this.hasNotificationTarget) {
      this.notificationTarget.style.display = 'none'
    }
  }

  showNotification() {
    if (this.hasNotificationTarget) {
      this.notificationTarget.style.display = 'block'
    }
  }

  markAsSeen() {
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + this.constructor.COOKIE_DURATION_YEARS)

    document.cookie = `${this.constructor.COOKIE_NAME}=true; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`
    
    this.hideNotification()
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }
}
